import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined
} from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Dropdown, Space } from "antd";
import TableAntd from "components/elements/Table/Table";
import i18n from "i18n";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "utils/formatter";

const CompanyConfigMailTable = ({
  onEdit = () => { },
  onDelete = () => { },
  onView = () => { },
  onChange = () => { },
  isLoading = false,
  pagination = {},
  configMailList = [],
}) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: <div className="text-table">{t("companyConfigMail.hostName")}</div>,
      dataIndex: "hostCustomize",
      key: "hostCustomize",
      width: '40px',
    },
    {
      title: <div className="text-table">{t("companyConfigMail.port")}</div>,
      dataIndex: "port",
      key: "port",
      width: '40px',
    },
    {
      title: <div className="text-table">{t("companyConfigMail.username")}</div>,
      dataIndex: "username",
      key: "username",
      width: '40px',
    },
    {
      title: <div className="text-table">{t("companyConfigMail.createDate")}</div>,
      dataIndex: "createDate",
      key: "createDate",
      width: '40px',
      render: (_, record) => {
        return formatDateTime(record.createDate)
      }
    },
    {
      title: <div className="text-table">{t("companyConfigMail.createBy")}</div>,
      dataIndex: "createBy",
      key: "createBy",
      width: '40px',
      render: (_, record) => {
        const name =
          i18n.language === "en"
            ? record.createBy.nameAndSurnameEn
            : record.createBy.nameAndSurname;
        return name;
      },
    },
    {
      title: <div className="text-table">{t("companyConfigMail.updateDate")}</div>,
      dataIndex: "updateDate",
      key: "updateDate",
      width: '40px',
      render: (_, record) => {
        return formatDateTime(record.updateDate)
      }
    },
    {
      title: <div className="text-table">{t("companyConfigMail.updateBy")}</div>,
      dataIndex: "updateBy",
      key: "updateBy",
      width: '40px',
      render: (_, record) => {
        const name =
          i18n.language === "en"
            ? record.updateBy.nameAndSurnameEn
            : record.updateBy.nameAndSurname;
        return name;
      },
    },
    {
      title: "",
      key: "action",
      width: '40px',
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => onView(record),
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "2",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                {
                  key: "3",
                  onClick: () => onDelete(record?.id),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
      }}
      dataSource={configMailList}
      columns={columns}
      onChange={onChange}
      // scroll={{ x: '1000px' }}
      tableLayout="fixed"
    />
  );
};

export default CompanyConfigMailTable;
